import { useQuery } from "@apollo/client";
import type {
  DataSourceDefinitionsResponse,
  UseDataSourceDefinitionOptions,
  UseDataSourceDefinitionResult,
} from "./types";
import { GET_DATA_SOURCE_DEFINITIONS } from "./APIs/DataSourcesApi";

const useDataSourceDefinition = (
  options: UseDataSourceDefinitionOptions = {}
): UseDataSourceDefinitionResult => {
  const {
    withLastReceived = false,
    withTags = false,
    filters = {},
    fetchPolicy = "cache-first",
  } = options;

  const {
    data: integratedDataSources,
    error: integratedDataSourcesError,
    loading,
  } = useQuery<DataSourceDefinitionsResponse>(GET_DATA_SOURCE_DEFINITIONS, {
    fetchPolicy,
    variables: {
      with_last_received: withLastReceived,
      with_tags: withTags,
      filters,
    },
  });

  return { integratedDataSources, integratedDataSourcesError, loading };
};

export default useDataSourceDefinition;
